import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Aysha Isah Ibrahim", 10, 6.0, 24, 4.0),
  createData("Asiya Haruna", 10.2, 9.0, 37, 2.3),
  createData("Uncle Uthman", 5, 10.0, 24, 4.0),
  createData("Marzool", 40, 3.7, 67, 4.3),
  createData("Azzra Isah Umar", 5, 10.0, 20, 3.9),
  createData("Hafsa Ali Bayaro", 5, 10.0, 20, 2.9),
  createData("Beeber Lhurv", 5, 10.0, 20, 1.9),
  createData("Haseena Isah Ibraheem", 5, 10.0, 20, 2.9),
  createData("Luwa'ul Hamdi", 5, 10.0, 20, 3.9),
  createData("Ibrahim Kabiru Bala", 5, 10.0, 20, 3.9),
  createData("Yusrah Abdullahee", 5, 10.0, 20, 3.9),
];

export default function BasicTable() {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Names</TableCell>
            <TableCell align="right">Maths</TableCell>
            <TableCell align="right">Physics</TableCell>
            <TableCell align="right">Chemitry</TableCell>
            <TableCell align="right">English</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.calories}</TableCell>
              <TableCell align="right">{row.fat}</TableCell>
              <TableCell align="right">{row.carbs}</TableCell>
              <TableCell align="right">{row.protein}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
